import { useFormContext, Controller, RegisterOptions } from "react-hook-form";
import { TextField, type TextFieldProps } from "@mui/material";

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  disabled?: boolean;
  rules?:RegisterOptions
};

export function RHFTextField({ name, helperText, disabled,rules, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          error={!!error}
          disabled={disabled}
          helperText={error ? error?.message : helperText}
          value={
            typeof field.value === "number" && field.value === 0
              ? "0"
              : field.value
          }
          onChange={(e) => {
            const { value } = e.target;
            field.onChange(value === "0" ? 0 : value);
          }}
          {...other}
        />
      )}
    />
  );
}
